module.exports = __webpack_public_path__ + "img/mallasombra.9fb0f1e4.jpg";